// extracted by mini-css-extract-plugin
export var back = "login-module--back--gjsSb";
export var close = "login-module--close--1avqn";
export var error = "login-module--error--LfqId";
export var form = "login-module--form--45Vqv";
export var loginPage = "login-module--login-page--pIPQ4";
export var sectionContainer = "login-module--section-container--3QeFt";
export var spinner = "login-module--spinner--hhYV-";
export var subContainer = "login-module--sub-container--AcILO";